var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('index-header'),_c('router-view'),_c('index-footer',{staticStyle:{"margin-top":"120px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }